// extracted by mini-css-extract-plugin
export default {"overflow-container":"_2MV05b1qS-","overflowContainer":"_2MV05b1qS-"};
    if(module.hot) {
      // 1627035587925
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  